import type { IAuthSignInDto, IAuthSignInResponse } from "./types";
import type { IPathBaseParam } from "./path";

import type { IApiResponse } from "@/api";
import { createPostApi } from "@api/util/createPostApi";

const postApis = createPostApi<
  IApiResponse<IAuthSignInResponse>,
  IPathBaseParam,
  IAuthSignInDto
>("auth.signIn");

export const signIn = {
  ...postApis,
};
